import React, { useContext, useEffect, useState } from 'react';
import { Button, Modal } from 'antd';
import GeneralContext from '../../context/GeneralContext/GeneralContext';
import { displayMessage } from '../../services/helper';
import { DateTime } from 'luxon';
import styles from '../../services/styles';
import EEventTypes from '../../patients/enums/EEventTypes';
import { DownOutlined, UpOutlined } from '@ant-design/icons';
import smile_emoji from '../../assets/smile_emoji.png'
import neutral_emoji from '../../assets/neutral_emoji.png'
import sad_emoji from '../../assets/sad-emojo.png'
const { bc9, bc10 } = styles

export default function ListControlDetailModal({isModalVisible, handleOnCloseModal, detailModalShowExercise, monitoryEvents, exerciseEvents, exerciseSections, monitorySections}){
    const {mobile_mode} = useContext(GeneralContext)
    const [tabSelected, setTabSelected] = useState([1])
    const [infraction, setInfractions] = useState([0,0,0,0,0,0])

    const handleOpentab = (tab_id) => {setTabSelected([tab_id])}

    function EmojiScore ({score}) {
        const smile_emoji_min = 3
        const neutral_emoji_min = 2
        const targetEmoji = ( score >= smile_emoji_min ? 
            smile_emoji :
            score >=  neutral_emoji_min ? 
                neutral_emoji : sad_emoji
        )
        return(
            <div style={{display: 'flex', flexDirection: 'row'}}>
                {<img width={'22px'} style={{ marginLeft: '12px', margin: 0, padding: 0 }} src={targetEmoji} />}
            </div>
        )
    }

    useEffect(()=>{
        const infractionsCodes = [1,3,4,7,8,10]
        const allEvents = [...(exerciseEvents || []), ...(monitoryEvents || [])]
        const newInfractions = infractionsCodes.map(code => 
            allEvents.filter(event => event.event_type === code).length
        )
        setInfractions(newInfractions)
    },[exerciseEvents, monitoryEvents])

    return(
        <Modal
            title={<div style={{display: 'flex', flexDirection: 'column'}}>
                <div style={{fontSize: 24, fontWeight: 'bold', display: 'flex', flex:1, alignItems: 'center', gap: '3px', color: bc9}}>
                    {displayMessage(detailModalShowExercise ?  'EXERCISE' : 'MONITORY')}
                </div>
            </div>
            }
            visible={isModalVisible}
            onCancel={() => handleOnCloseModal()}
            centered={true}
            width={mobile_mode ? '90%' : 750}
            style={{ position: 'relative', borderRadius: '20px'}}
            bodyStyle={{ display: 'flex', flexDirection: 'column', gap: 10, borderRadius: '20px'}}
            className='affected-modal'
            footer={
                tabSelected.includes(1) ?
                <div style={{display: 'flex', minHeight: 30, width: '100%', marginTop: 20, flexDirection: 'column'}} >
                    <div style={{fontSize: 24, color: bc9, fontWeight: 'bold' , display: 'flex', justifyContent: 'flex-start', alignItems: 'center', width: '100%'}} >
                        {displayMessage("INFRACTIONS")}
                    </div>
                    <div style={{display: 'flex', justifyContent: 'flex-start', alignItems: 'center', width: '100%', paddingLeft: 10}} >
                        <div style={{display: 'flex', flex: 1, justifyContent: 'flex-start', alignItems: 'center', fontWeight: 'bold', gap: 5}}>
                            {displayMessage(
                                !detailModalShowExercise ?
                                "OPEN_LIP" : "CAMERA_POSITION"
                            )+": "}
                            <div style={{fontWeight: 'normal'}}>
                                {(infraction && infraction?.length > 0) ?
                                    infraction[ !detailModalShowExercise ? 0 : 3 ] : 0
                                }
                            </div>
                        </div>
                        <div style={{display: 'flex', flex: 1, justifyContent: 'flex-start', alignItems: 'center', fontWeight: 'bold', gap: 5}}>
                            {displayMessage(
                                !detailModalShowExercise ?
                                "CAMERA_OFF" : "CORRECT_EXECUTION"
                            )+": "}
                            <div style={{fontWeight: 'normal'}}>
                                {(infraction && infraction?.length > 0) ?
                                    infraction[ !detailModalShowExercise ? 1 : 4 ] : 0
                                }
                            </div>
                        </div>
                        <div style={{display: 'flex', flex: 1, justifyContent: 'flex-start', alignItems: 'center', fontWeight: 'bold', gap: 5}}>
                            {displayMessage(
                                !detailModalShowExercise ?
                                "CHEWING" : "CONCENTRATION_ACTIVITY"
                            )+": "}
                            <div style={{fontWeight: 'normal'}}>
                                {(infraction && infraction?.length > 0) ?
                                    infraction[ !detailModalShowExercise ? 2 : 5 ] : 0
                                }
                            </div>
                        </div>
                    </div>
                </div>
                : null
            }
        >
            <div style={{display: 'flex', width: '100%', flexDirection: 'row', justifyContent: 'space-evenly', gap: 10, marginBottom: 10}}>
                <Button 
                    onClick={()=>handleOpentab(1)}
                    style={{
                        display: 'flex', flex: 1, borderRadius: '20px', flexDirection: 'row', justifyContent: 'space-between', 
                        backgroundColor: tabSelected.includes(1) ? 'white' : bc9,
                        color: tabSelected.includes(1) ? bc9 : 'white',
                        borderWidth:2,
                        borderColor: tabSelected.includes(1) ? bc9 : 'white',
                    }}
                    type='primary'
                > 
                    <div style={{display:  'flex', flex: 1, alignItems: 'center', justifyContent: 'center', paddingLeft: 14}}>
                        {displayMessage("EVENTS")}
                    </div>
                    <div style={{display:  'flex', alignItems: 'center', justifyContent: 'flex-end'}}>
                        { tabSelected.includes(1) ? <UpOutlined/> : <DownOutlined />}
                    </div>
                </Button>
                <Button 
                    onClick={()=>handleOpentab(2)}
                    style={{
                        display: 'flex', flex: 1, borderRadius: '20px', flexDirection: 'row', justifyContent: 'space-between', 
                        backgroundColor: tabSelected.includes(2) ? 'white' : bc9,
                        color: tabSelected.includes(2) ? bc9 : 'white',
                        borderWidth:2,
                        borderColor: tabSelected.includes(2) ? bc9 : 'white',
                    }}
                    type='primary'
                > 
                    <div style={{display:  'flex', flex: 1, alignItems: 'center', justifyContent: 'center', paddingLeft: 14}}>
                        {displayMessage("FEEDBACK")}
                    </div>
                    <div style={{display:  'flex', alignItems: 'center', justifyContent: 'flex-end'}}>
                        { tabSelected.includes(2) ? <UpOutlined/> : <DownOutlined />}
                    </div>
                </Button>
            </div>
            { tabSelected.includes(1) &&
                <div style={{display: 'flex', flex: 1, flexDirection: 'column', justifyContent: 'center', alignItems: 'center'}}>

                    <div style={{display: 'flex', width: '100%', flexDirection: 'row', justifyContent: 'space-around', alignItems: 'center', fontWeight: 'bold'}}> 
                        <div className='flex-1 pl-1'>{displayMessage('EVENT_TYPE')}</div> 
                        <div className='flex-1'>{displayMessage('EVENT_DATE')}</div> 
                    </div>
                    <hr style={{ width: '100%', borderColor: 'black', margin: '10px 0', borderWidth: '1px' }} />
                    { (detailModalShowExercise && exerciseEvents && exerciseEvents?.length>0)&&
                        exerciseEvents.map((e, index) => (
                            <div  style={{display: 'flex', width: '100%', flexDirection: 'column'}}>
                                <div key={index} style={{display: 'flex', width: '100%', flexDirection: 'row', justifyContent: 'space-around', alignItems: 'center'}}> 
                                    <div className='flex-1 pl-1'> {Object.values(EEventTypes).find(f => f.code == e?.event_type)?.description} </div>
                                    <div className='flex-1'> {e?.timestamp ? DateTime.fromISO(e?.timestamp, { zone: 'local' }).toFormat('dd/MM/yyyy HH:mm:ss') : displayMessage('NOT_INFORMED2')} </div>
                                </div>
                                {index < exerciseEvents.length - 1 && <hr style={{ width: '100%', borderColor: 'black', margin: '10px 0', borderWidth: '0,2px' }} />}
                            </div>
                        ))
                    }
                    { (!detailModalShowExercise && monitoryEvents && monitoryEvents?.length>0) &&
                        monitoryEvents.map((e, index) => (
                            <div  style={{display: 'flex', width: '100%', flexDirection: 'column'}}>
                                <div key={index} style={{display: 'flex', width: '100%', flexDirection: 'row', justifyContent: 'space-around', alignItems: 'center'}}> 
                                    <div className='flex-1 pl-1'> {Object.values(EEventTypes).find(f => f.code == e?.event_type)?.description} </div>
                                    <div className='flex-1'> {e?.timestamp ? DateTime.fromISO(e?.timestamp, { zone: 'local' }).toFormat('dd/MM/yyyy HH:mm:ss') : displayMessage('NOT_INFORMED2')} </div>
                                </div>
                                {index < monitoryEvents.length - 1 && <hr style={{ width: '100%', borderColor: 'black', margin: '10px 0', borderWidth: '0,2px' }} />}
                            </div>
                        ))
                    }
                </div>
            }
            { tabSelected.includes(2) &&
                <div style={{display: 'flex', flex: 1, flexDirection: 'column', justifyContent: 'center', alignItems: 'center'}}>
                     <div style={{display: 'flex', width: '100%', flexDirection: 'row', justifyContent: 'space-around', alignItems: 'center', fontWeight: 'bold'}}> 
                        <div className='flex-1'>{displayMessage('EVENT_DATE')}</div> 
                        <div className='flex-1 pl-1'>{displayMessage('DESCRIPTION')}</div> 
                        <div className='flex-1'>{displayMessage('SCORE')}</div> 
                    </div>
                    <hr style={{ width: '100%', borderColor: 'black', margin: '10px 0', borderWidth: '1px' }} />
                    { (detailModalShowExercise && exerciseSections && exerciseSections?.length>0)&&
                        exerciseSections.map((e, index) => (
                            <div  style={{display: 'flex', width: '100%', flexDirection: 'column'}}>
                                <div key={index} style={{display: 'flex', width: '100%', flexDirection: 'row', justifyContent: 'space-around', alignItems: 'center'}}> 
                                    <div className='flex-1'> {e?.created_at ? DateTime.fromISO(e?.created_at, { zone: 'local' }).toFormat('dd/MM/yyyy HH:mm:ss') : displayMessage('NOT_INFORMED2')} </div>
                                    <div className='flex-1 pl-1'> {e?.feedback_text || ""} </div>
                                    <div className='flex-1 pl-1'> 
                                        <EmojiScore score={(Math.floor(e?.feedback_rating))}/>
                                    </div>
                                </div>
                                {index < exerciseSections.length - 1 && <hr style={{ width: '100%', borderColor: 'black', margin: '10px 0', borderWidth: '0,2px' }} />}
                            </div>
                        ))
                    }
                    { (!detailModalShowExercise && monitorySections && monitorySections?.length>0) &&
                        monitorySections.map((e, index) => (
                            <div  style={{display: 'flex', width: '100%', flexDirection: 'column'}}>
                                <div key={index} style={{display: 'flex', width: '100%', flexDirection: 'row', justifyContent: 'space-around', alignItems: 'center'}}> 
                                    <div className='flex-1'> {e?.created_at ? DateTime.fromISO(e?.created_at, { zone: 'local' }).toFormat('dd/MM/yyyy HH:mm:ss') : displayMessage('NOT_INFORMED2')} </div>
                                    <div className='flex-1 pl-1'> {e?.feedback_text || ""} </div>
                                    <div className='flex-1 pl-1'> 
                                        <EmojiScore score={(Math.floor(e?.feedback_rating))}/>
                                    </div>
                                </div>
                                {index < monitorySections.length - 1 && <hr style={{ width: '100%', borderColor: 'black', margin: '10px 0', borderWidth: '0,2px' }} />}
                            </div>
                        ))
                    }
                </div>
            }
        </Modal>
    )
}